module.exports = __webpack_public_path__ + "static/media/logo-vio.8d7bbf63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-vio.png
// module id = 249
// module chunks = 0